"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Checkbox = Checkbox;
exports.enhance = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withHandlers = _interopRequireDefault(require("recompose/withHandlers"));

var _clickTracking = _interopRequireDefault(require("./tracking-lib/tracking/clickTracking"));

var enhance = (0, _compose["default"])(_clickTracking["default"], (0, _withHandlers["default"])({
  onCheckboxClick: function onCheckboxClick(_ref) {
    var handleClick = _ref.handleClick,
        checked = _ref.checked,
        onChange = _ref.onChange;
    return function (e) {
      handleClick(e);
      onChange(!checked);
    };
  }
}));
exports.enhance = enhance;

function Checkbox(_ref2) {
  var _classnames;

  var id = _ref2.id,
      checked = _ref2.checked,
      children = _ref2.children,
      className = _ref2.className,
      onCheckboxClick = _ref2.onCheckboxClick,
      name = _ref2.name,
      value = _ref2.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames2["default"])((_classnames = {}, _classnames[className + "-label"] = className, _classnames)),
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    checked: checked,
    onChange: onCheckboxClick
  }), children));
}

Checkbox.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  checked: _propTypes["default"].bool,
  onCheckboxClick: _propTypes["default"].func,
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string
};

var _default = enhance(Checkbox);

exports["default"] = _default;